import { questionConstants } from '../../constants';

const initialQuestionsState = {
  questionsList: [] as any[],
  pagination: {
    page: 1,
    limit: 4,
    total: 0,
    totalPages: 0,
  },
};

export function questions(state = initialQuestionsState, action: any) {
  switch (action.type) {
    case questionConstants.GETALL_REQUEST:
      return { ...state, loading: true };
    case questionConstants.GETALL_SUCCESS:
      // Handle both old format (array) and new format (object with questions + pagination)
      if (Array.isArray(action.payload)) {
        return { ...state, questionsList: action.payload, loading: false };
      } else {
        return { 
          ...state, 
          questionsList: action.payload.questions || [], 
          pagination: action.payload.pagination || state.pagination,
          loading: false 
        };
      }
    case questionConstants.GETALL_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case questionConstants.CREATE_SUCCESS:
      return { questionsList: [...state.questionsList, action.payload] };
    case questionConstants.DELETE_SUCCESS:
      return { 
        ...state, 
        questionsList: state.questionsList.filter(question => question.id !== action.payload)
      };
    case questionConstants.DELETE_MULTIPLE_SUCCESS:
      return {
        ...state,
        questionsList: state.questionsList.filter(question => !action.payload.includes(question.id))
      };
    case questionConstants.UPDATE_SUCCESS:
      return { 
        ...state, 
        questionsList: state.questionsList.map(question =>
          question.id === action.payload.id ? action.payload : question
        ),
      };
    default:
      return state;
  }
}
